import { matchers } from "../../validate-props";

const reducerName = "fileInputReducer";

export const types = Object.freeze({
    setFieldError: "SET_FIELD_ERROR",
    addListItem: "ADD_LIST_ITEM",
    removeListItem: "REMOVE_LIST_ITEM",
    setListItemError: "SET_LIST_ITEM_ERROR",
});

export const actions = Object.freeze({
    setFieldError: (fieldError) => {
        return { type: types.setFieldError, fieldError };
    },
    addListItem: (item) => {
        return { type: types.addListItem, item };
    },
    removeListItem: (id) => {
        return { type: types.removeListItem, id };
    },
    setListItemError: (id, error) => {
        return { type: types.setListItemError, id, error };
    },
});

/**
 * Handles states.
 * @param {{
 *   fieldError: boolean
 *   list: []
 *   validItemCount: number
 *   fullItemCount: number
 * }} state
 * @param {{
 *   type: String,
 *   payload: {
 *     fieldError: boolean
 *   } | {
 *     item: {}
 *   } | {
 *     id: string
 *   }
 *  }} action created by an Action Creator
 * @returns {}
 */
export const fileInputReducer = (state, action) => {
    //Unexpected state coming
    if (!matchers.object(state)) return state;

    //Unexpected action
    if (!matchers.and(matchers.object(action), action.type in types)) return state;

    const getValidItemCount = () => {
        return state.list.filter((item) => !item.error).length;
    };

    const getFullCount = () => {
        return state.list.length;
    };

    //Expected types
    switch (action.type) {
        case types.setFieldError:
            if (!matchers.boolean(action.fieldError)) {
                console.warn(`${reducerName}: fieldError must be of type boolean.`);
                return state;
            }
            state.fieldError = action.fieldError;
            return state;

        case types.addListItem:
            if (!matchers.object(action.item)) {
                console.warn(`${reducerName}: item must be of type object.`);
                return state;
            }
            state.list.push(action.item);
            state.validItemCount = getValidItemCount();
            state.fullItemCount = getFullCount();
            return state;

        case types.removeListItem:
            if (!matchers.string(action.id)) {
                console.warn(`${reducerName}: id must be of type string.`);
                return state;
            }

            state.list = state.list.filter((item) => item.id !== action.id);

            state.validItemCount = getValidItemCount();
            state.fullItemCount = getFullCount();
            return state;

        case types.setListItemError:
            if (!matchers.string(action.id)) {
                console.warn(`${reducerName}: id must be of type string.`);
                return state;
            }
            if (!matchers.string(action.error)) {
                console.warn(`${reducerName}: error must be of type string.`);
                return state;
            }
            state.list.forEach((item) => {
                if (item.id === action.id) {
                    item.error = action.error;
                    state.validItemCount = getValidItemCount();
                }
            });
            return state;

        default:
            return state;
    }
};
